import { render, staticRenderFns } from "./ToolBar.vue?vue&type=template&id=6fd0a4a6&scoped=true&"
import script from "./ToolBar.vue?vue&type=script&lang=js&"
export * from "./ToolBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fd0a4a6",
  null
  
)

export default component.exports